// ─── Formatting utilities ─────────────────────────────────────────────────────

export const fmt = (n) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0,
  }).format(n ?? 0);
